import React from 'react';
import { motion } from 'framer-motion';
import styles from './LessonContentRenderer.module.css';
import videoStyles from './VideoCard.module.css';

interface VideoCardProps {
    number: string;
    title: string;
    summary: string;
    videoUrl: string;
    videoPoster?: string;
    caption?: string;
    captionType?: 'bar' | 'icon';
    variant?: 'default' | 'theme' | 'authority' | 'impact' | 'stats';
}

const VideoCard: React.FC<VideoCardProps> = ({
    number,
    title,
    summary,
    videoUrl,
    videoPoster,
    caption,
    captionType = 'bar',
    variant = 'default'
}) => {
    const displayNumber = number.length === 1 ? `0${number}` : number;

    const containerClassName = `
        ${videoStyles.videoCardContainer}
        ${variant === 'theme' ? videoStyles.videoCardTheme : ''}
        ${variant === 'authority' ? videoStyles.videoCardAuthority : ''}
        ${variant === 'impact' ? videoStyles.videoCardImpact : ''}
        ${variant === 'stats' ? videoStyles.videoCardStats : ''}
    `.trim();

    return (
        <motion.div
            className={containerClassName}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.5, ease: 'easeOut' }}
        >
            <div className={videoStyles.videoCardAccent} />
            <div className={videoStyles.videoCardBody}>
                <div className={styles.sectionCardHeader}>
                    {variant === 'default' && (
                        <div className={styles.sectionCardNumber}>
                            {displayNumber}
                        </div>
                    )}
                    <div className={styles.sectionCardTitleContainer}>
                        <h3 className={styles.sectionCardTitle}>{title}</h3>
                        <p className={styles.sectionCardSummary}>{summary}</p>
                    </div>
                </div>

                {videoUrl && (
                    <div className={videoStyles.videoCardVideoContainer}>
                        <video
                            src={videoUrl}
                            poster={videoPoster}
                            autoPlay
                            loop
                            muted
                            className={videoStyles.videoElement}
                        />

                        {caption && captionType === 'bar' && (
                            <div className={styles.imageCaptionBar}>
                                <span>{caption}</span>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </motion.div>
    );
};

export default VideoCard;
